import React from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SvgMirs from './SvgMirs';

const isBlanc = move => {
  return isNaN(move);
};

const isZero = move => {
  return (move === '0' || move === 0);
};


const isMoveUp = move => {
  return Number(move) > 0;
};

export const Movement = React.memo(({ move }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  //console.log('NOC  rendered', props)

  if (isBlanc(move)) return null;

  if (isZero(move)) return <div className='move-arrow-number'><div className='text-center'>=</div></div>;
  return (
    <div className='move-arrow-number'>
      <div className='move-arrow'>
        {isMoveUp(move)
          ? <SvgMirs className='mirsIcon' title='LabelMoveUp' code='arrow-up' />
          : <SvgMirs className='mirsIcon' title='LabelMoveDown' code='arrow-down' />
        }

      </div>
      <div className='move-number'>
        {'|MTB|GLF'.includes(mirs_discipline)
          ? move.slice(1)
          : move
        }
      </div>
    </div>
  )
});

export default Movement